/**
 * Use the CSS tab above to style your Element's container.
 */
import React from "react";
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  AddressElement,
  CardElement,
} from "@stripe/react-stripe-js";
import "./Styles.css";
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#B9B9B9",
      fontFamily: "Noto Sans JP",
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
  placeholder: "0000000000000000 ※ハイフン不要",
};
function CardSection() {
  return (
    <div>
      Card details
      {/* <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
      <CardCvcElement />
      <CardExpiryElement /> */}
      <CardElement options={CARD_ELEMENT_OPTIONS} />
    </div>
  );
}
export default CardSection;
